/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * InstaLaw Forms API
 * OpenAPI spec version: 0.0.1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import axios from 'axios';
import type {
  AxiosError,
  AxiosRequestConfig,
  AxiosResponse
} from 'axios';

export interface FormConfig {
  id: string;
  org: string;
  slug: string;
  title: string;
  sections: FormSection[];
  submitButtonText?: string;
  successMessage?: string;
  redirectUrl?: string;
}

export interface FormSection {
  id: string;
  title?: string;
  description?: string;
  fields: FormField[];
}

export type FormFieldType = typeof FormFieldType[keyof typeof FormFieldType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FormFieldType = {
  text: 'text',
  textarea: 'textarea',
  email: 'email',
  phone: 'phone',
  number: 'number',
  date: 'date',
  select: 'select',
  checkbox: 'checkbox',
  radio: 'radio',
  file: 'file',
} as const;

export interface FormField {
  id: string;
  label?: string;
  type: FormFieldType;
  required?: boolean;
  placeholder?: string;
  helpText?: string;
  options?: Option[];
  multiple?: boolean;
  accept?: string;
  maxSizeMb?: number;
}

export interface Option {
  value: string;
  label: string;
}

export interface PresignRequest {
  fieldId: string;
  fileName: string;
  contentType: string;
  size: number;
}

export type PresignResponseFields = {[key: string]: string};

export type PresignResponseHeaders = {[key: string]: string};

export interface PresignResponse {
  url: string;
  fields?: PresignResponseFields;
  headers?: PresignResponseHeaders;
}

export type SubmitFormBodyData = { [key: string]: unknown };

export interface SubmitFormBody {
  formId: string;
  data: SubmitFormBodyData;
}

export type FileStatusStatus = typeof FileStatusStatus[keyof typeof FileStatusStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FileStatusStatus = {
  pending_scan: 'pending_scan',
  clean: 'clean',
  infected: 'infected',
  quarantined: 'quarantined',
} as const;

export interface FileStatus {
  id: string;
  status: FileStatusStatus;
  updatedAt?: string;
  scanTag?: string;
}

export interface CreateFormRequest {
  org: string;
  slug: string;
  title: string;
  sections: FormSection[];
}

export interface FormSummary {
  id: string;
  org: string;
  slug: string;
  title: string;
  publishedAt?: string;
}

export type SubmissionListItemsItem = { [key: string]: unknown };

export interface SubmissionList {
  items: SubmissionListItemsItem[];
  page: number;
  pageSize: number;
  total: number;
}

export type S3GuardDutyEventsBody = { [key: string]: unknown };

export type ListResponsesParams = {
/**
 * @minimum 1
 */
page?: number;
/**
 * @minimum 1
 * @maximum 200
 */
pageSize?: number;
};

export type GetPortal200 = { [key: string]: unknown };

export type ListPortalPages200Item = { [key: string]: unknown };

export const getFormConfigBySlug = (
    org: string,
    slug: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<FormConfig>> => {
    
    
    return axios.get(
      `/api/form-config/${org}/${slug}`,options
    );
  }


export const getGetFormConfigBySlugQueryKey = (org?: string,
    slug?: string,) => {
    return [`/api/form-config/${org}/${slug}`] as const;
    }

    
export const getGetFormConfigBySlugQueryOptions = <TData = Awaited<ReturnType<typeof getFormConfigBySlug>>, TError = AxiosError<null>>(org: string,
    slug: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getFormConfigBySlug>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFormConfigBySlugQueryKey(org,slug);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFormConfigBySlug>>> = ({ signal }) => getFormConfigBySlug(org,slug, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(org && slug), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFormConfigBySlug>>, TError, TData> & { queryKey: QueryKey }
}

export type GetFormConfigBySlugQueryResult = NonNullable<Awaited<ReturnType<typeof getFormConfigBySlug>>>
export type GetFormConfigBySlugQueryError = AxiosError<null>



export function useGetFormConfigBySlug<TData = Awaited<ReturnType<typeof getFormConfigBySlug>>, TError = AxiosError<null>>(
 org: string,
    slug: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getFormConfigBySlug>>, TError, TData>, axios?: AxiosRequestConfig}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetFormConfigBySlugQueryOptions(org,slug,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const presignUpload = (
    org: string,
    slug: string,
    presignRequest: PresignRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PresignResponse>> => {
    
    
    return axios.post(
      `/api/forms/${org}/${slug}/presign`,
      presignRequest,options
    );
  }



export const getPresignUploadMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof presignUpload>>, TError,{org: string;slug: string;data: PresignRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof presignUpload>>, TError,{org: string;slug: string;data: PresignRequest}, TContext> => {

const mutationKey = ['presignUpload'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof presignUpload>>, {org: string;slug: string;data: PresignRequest}> = (props) => {
          const {org,slug,data} = props ?? {};

          return  presignUpload(org,slug,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PresignUploadMutationResult = NonNullable<Awaited<ReturnType<typeof presignUpload>>>
    export type PresignUploadMutationBody = PresignRequest
    export type PresignUploadMutationError = AxiosError<unknown>

    export const usePresignUpload = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof presignUpload>>, TError,{org: string;slug: string;data: PresignRequest}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof presignUpload>>,
        TError,
        {org: string;slug: string;data: PresignRequest},
        TContext
      > => {

      const mutationOptions = getPresignUploadMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const submitFormBySlug = (
    org: string,
    slug: string,
    submitFormBody: SubmitFormBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<null>> => {
    
    
    return axios.post(
      `/api/forms/${org}/${slug}/submit`,
      submitFormBody,options
    );
  }



export const getSubmitFormBySlugMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitFormBySlug>>, TError,{org: string;slug: string;data: SubmitFormBody}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof submitFormBySlug>>, TError,{org: string;slug: string;data: SubmitFormBody}, TContext> => {

const mutationKey = ['submitFormBySlug'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitFormBySlug>>, {org: string;slug: string;data: SubmitFormBody}> = (props) => {
          const {org,slug,data} = props ?? {};

          return  submitFormBySlug(org,slug,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SubmitFormBySlugMutationResult = NonNullable<Awaited<ReturnType<typeof submitFormBySlug>>>
    export type SubmitFormBySlugMutationBody = SubmitFormBody
    export type SubmitFormBySlugMutationError = AxiosError<unknown>

    export const useSubmitFormBySlug = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitFormBySlug>>, TError,{org: string;slug: string;data: SubmitFormBody}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof submitFormBySlug>>,
        TError,
        {org: string;slug: string;data: SubmitFormBody},
        TContext
      > => {

      const mutationOptions = getSubmitFormBySlugMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const getFileStatus = (
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<FileStatus>> => {
    
    
    return axios.get(
      `/api/files/${id}/status`,options
    );
  }


export const getGetFileStatusQueryKey = (id?: string,) => {
    return [`/api/files/${id}/status`] as const;
    }

    
export const getGetFileStatusQueryOptions = <TData = Awaited<ReturnType<typeof getFileStatus>>, TError = AxiosError<null>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getFileStatus>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFileStatusQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFileStatus>>> = ({ signal }) => getFileStatus(id, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFileStatus>>, TError, TData> & { queryKey: QueryKey }
}

export type GetFileStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getFileStatus>>>
export type GetFileStatusQueryError = AxiosError<null>



export function useGetFileStatus<TData = Awaited<ReturnType<typeof getFileStatus>>, TError = AxiosError<null>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getFileStatus>>, TError, TData>, axios?: AxiosRequestConfig}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetFileStatusQueryOptions(id,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const s3GuardDutyEvents = (
    s3GuardDutyEventsBody: S3GuardDutyEventsBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<null>> => {
    
    
    return axios.post(
      `/internal/s3/events`,
      s3GuardDutyEventsBody,options
    );
  }



export const getS3GuardDutyEventsMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof s3GuardDutyEvents>>, TError,{data: S3GuardDutyEventsBody}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof s3GuardDutyEvents>>, TError,{data: S3GuardDutyEventsBody}, TContext> => {

const mutationKey = ['s3GuardDutyEvents'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof s3GuardDutyEvents>>, {data: S3GuardDutyEventsBody}> = (props) => {
          const {data} = props ?? {};

          return  s3GuardDutyEvents(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type S3GuardDutyEventsMutationResult = NonNullable<Awaited<ReturnType<typeof s3GuardDutyEvents>>>
    export type S3GuardDutyEventsMutationBody = S3GuardDutyEventsBody
    export type S3GuardDutyEventsMutationError = AxiosError<unknown>

    export const useS3GuardDutyEvents = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof s3GuardDutyEvents>>, TError,{data: S3GuardDutyEventsBody}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof s3GuardDutyEvents>>,
        TError,
        {data: S3GuardDutyEventsBody},
        TContext
      > => {

      const mutationOptions = getS3GuardDutyEventsMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const createForm = (
    createFormRequest: CreateFormRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<FormSummary>> => {
    
    
    return axios.post(
      `/api/attorneys/forms`,
      createFormRequest,options
    );
  }



export const getCreateFormMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createForm>>, TError,{data: CreateFormRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createForm>>, TError,{data: CreateFormRequest}, TContext> => {

const mutationKey = ['createForm'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createForm>>, {data: CreateFormRequest}> = (props) => {
          const {data} = props ?? {};

          return  createForm(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateFormMutationResult = NonNullable<Awaited<ReturnType<typeof createForm>>>
    export type CreateFormMutationBody = CreateFormRequest
    export type CreateFormMutationError = AxiosError<unknown>

    export const useCreateForm = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createForm>>, TError,{data: CreateFormRequest}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createForm>>,
        TError,
        {data: CreateFormRequest},
        TContext
      > => {

      const mutationOptions = getCreateFormMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const getFormById = (
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<FormConfig>> => {
    
    
    return axios.get(
      `/api/attorneys/forms/${id}`,options
    );
  }


export const getGetFormByIdQueryKey = (id?: string,) => {
    return [`/api/attorneys/forms/${id}`] as const;
    }

    
export const getGetFormByIdQueryOptions = <TData = Awaited<ReturnType<typeof getFormById>>, TError = AxiosError<null>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getFormById>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFormByIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFormById>>> = ({ signal }) => getFormById(id, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFormById>>, TError, TData> & { queryKey: QueryKey }
}

export type GetFormByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getFormById>>>
export type GetFormByIdQueryError = AxiosError<null>



export function useGetFormById<TData = Awaited<ReturnType<typeof getFormById>>, TError = AxiosError<null>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getFormById>>, TError, TData>, axios?: AxiosRequestConfig}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetFormByIdQueryOptions(id,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const listResponses = (
    org: string,
    slug: string,
    params?: ListResponsesParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SubmissionList>> => {
    
    
    return axios.get(
      `/api/attorneys/forms/${org}/${slug}/responses`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getListResponsesQueryKey = (org?: string,
    slug?: string,
    params?: ListResponsesParams,) => {
    return [`/api/attorneys/forms/${org}/${slug}/responses`, ...(params ? [params]: [])] as const;
    }

    
export const getListResponsesQueryOptions = <TData = Awaited<ReturnType<typeof listResponses>>, TError = AxiosError<unknown>>(org: string,
    slug: string,
    params?: ListResponsesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listResponses>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListResponsesQueryKey(org,slug,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listResponses>>> = ({ signal }) => listResponses(org,slug,params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(org && slug), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listResponses>>, TError, TData> & { queryKey: QueryKey }
}

export type ListResponsesQueryResult = NonNullable<Awaited<ReturnType<typeof listResponses>>>
export type ListResponsesQueryError = AxiosError<unknown>



export function useListResponses<TData = Awaited<ReturnType<typeof listResponses>>, TError = AxiosError<unknown>>(
 org: string,
    slug: string,
    params?: ListResponsesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listResponses>>, TError, TData>, axios?: AxiosRequestConfig}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListResponsesQueryOptions(org,slug,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getPortal = (
    org: string,
    portalId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetPortal200>> => {
    
    
    return axios.get(
      `/api/portals/${org}/${portalId}`,options
    );
  }


export const getGetPortalQueryKey = (org?: string,
    portalId?: string,) => {
    return [`/api/portals/${org}/${portalId}`] as const;
    }

    
export const getGetPortalQueryOptions = <TData = Awaited<ReturnType<typeof getPortal>>, TError = AxiosError<null>>(org: string,
    portalId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPortal>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPortalQueryKey(org,portalId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPortal>>> = ({ signal }) => getPortal(org,portalId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(org && portalId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPortal>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPortalQueryResult = NonNullable<Awaited<ReturnType<typeof getPortal>>>
export type GetPortalQueryError = AxiosError<null>



export function useGetPortal<TData = Awaited<ReturnType<typeof getPortal>>, TError = AxiosError<null>>(
 org: string,
    portalId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPortal>>, TError, TData>, axios?: AxiosRequestConfig}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPortalQueryOptions(org,portalId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const listPortalPages = (
    org: string,
    portalId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ListPortalPages200Item[]>> => {
    
    
    return axios.get(
      `/api/portals/${org}/${portalId}/pages`,options
    );
  }


export const getListPortalPagesQueryKey = (org?: string,
    portalId?: string,) => {
    return [`/api/portals/${org}/${portalId}/pages`] as const;
    }

    
export const getListPortalPagesQueryOptions = <TData = Awaited<ReturnType<typeof listPortalPages>>, TError = AxiosError<unknown>>(org: string,
    portalId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPortalPages>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPortalPagesQueryKey(org,portalId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPortalPages>>> = ({ signal }) => listPortalPages(org,portalId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(org && portalId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPortalPages>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPortalPagesQueryResult = NonNullable<Awaited<ReturnType<typeof listPortalPages>>>
export type ListPortalPagesQueryError = AxiosError<unknown>



export function useListPortalPages<TData = Awaited<ReturnType<typeof listPortalPages>>, TError = AxiosError<unknown>>(
 org: string,
    portalId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPortalPages>>, TError, TData>, axios?: AxiosRequestConfig}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPortalPagesQueryOptions(org,portalId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}
